import { Dialog, Typography, Alert, AlertTitle } from '@mui/material';
import {
  ArchiveOrganizationWithCommunityMembersWarning,
  ArchiveOrgWithJournalistsWarning,
  BoldArchiveOrganizationWithCommunityMembersWarning,
  BoldArchiveOrgWthJournalistsWarning,
} from '../../shared/constants/constants';
import PropTypes from 'prop-types';

const AlertCannotArchiveOrg = (props) => {
  const { open, setOpen, isOrganizationCategory } = props;
  return (
    <Dialog open={open} onClose={() => setOpen(false)}>
      <Alert severity="warning" onClose={() => setOpen(false)}>
        <AlertTitle>Cannot Archive {isOrganizationCategory ? 'Organization' : 'Outlet'}</AlertTitle>
        <Typography variant="body2" paragraph={true}>
          {isOrganizationCategory ? ArchiveOrganizationWithCommunityMembersWarning : ArchiveOrgWithJournalistsWarning} —{' '}
          <strong>
            {isOrganizationCategory
              ? BoldArchiveOrganizationWithCommunityMembersWarning
              : BoldArchiveOrgWthJournalistsWarning}
          </strong>
        </Typography>
      </Alert>
    </Dialog>
  );
};
AlertCannotArchiveOrg.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  isOrganizationCategory: PropTypes.bool.isRequired,
};

export default AlertCannotArchiveOrg;
